import { createContext } from 'react';
import { emptyFn } from '@/lib/utils';

export interface DialogContext {
  openStarUsDialog: () => void;
  closeStarUsDialog: () => void;
}

export const dialogContext = createContext<DialogContext>({
  openStarUsDialog: emptyFn,
  closeStarUsDialog: emptyFn,
});
